/* eslint-disable */

// import RaindropAdvertisement from "../../../ui-components/raindrop-advertisement/raindrop-advertisement.tsx";
import React, { useEffect } from "react";

import { fetchGraphQL } from "../../../services/api-raindrop";

import NimbusTable from "../../../ui-components/nimbus-table/nimbus-table.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";

const NimbusAccountPlanExecutionTable = () => {
  const [data, setData] = React.useState<any>([]);
  useEffect(() => {
    fetchGraphQL(`
      query {
        accountPlanObjectsForExecution {
          id
          account {
            id
            username
            userObjects {
              id
            }
          }
        }
      }
    `).then((response) => {
      console.log("Account Plan Objects for Execution", response);
      setData(
        response.data.accountPlanObjectsForExecution.map((item: any) => ({
          id: item.id,
          account_id: item.account.id,
          username: item.account?.username,
          account_user: item.account?.userObjects[0]?.id,
          profile: (
            <RaindropButton
              to={`/nimbus/users/${item.account?.userObjects[0]?.id}`}
            />
          ),
        }))
      );
    });
  }, []);

  const columns = [
    {
      title: "ID",
      accessor: "id",
    },
    {
      title: "Account ID",
      accessor: "account_id",
    },
    {
      title: "Username",
      accessor: "username",
    },
    {
      title: "Go to Profile",
      accessor: "profile",
    },
  ];
  return (
    <RaindropCard>
      <h1 className="text-xl font-black w-full text-left">
        Account Plans to be executed today
      </h1>
      <NimbusTable columns={columns} data={data} />
    </RaindropCard>
  );
};

const NimbusHome = () => {
  return (
    <div className="flex flex-col h-full items-center justify-center text-center gap-2">
      {/* <RaindropAdvertisement /> */}
      <div className="text-4xl font-bold text-color-raindrop-minor-again">
        Welcome to Nimbus
      </div>
      <div className="text-lg font-bold text-color-raindrop-disabled">
        Simplicity. Consistency. Kindness.
      </div>

      <NimbusAccountPlanExecutionTable />
    </div>
  );
};

export default NimbusHome;
